/**
 * Schedule API - User Schedule
 *
 * User-focused schedule endpoints (mobile-focused).
 */

import { z } from 'zod'
import { UserScheduleSchema, MeetingSchema, DayScheduleSchema } from './common'

// ============================================================================
// GET /v1/schedule
// ============================================================================

export const GetScheduleRequestSchema = z.object({
  startDate: z.string().optional(),
  endDate: z.string().optional(),
  userId: z.string().optional()
})

export type GetScheduleRequest = z.infer<typeof GetScheduleRequestSchema>

export const GetScheduleResponseSchema = z.object({
  data: UserScheduleSchema,
  message: z.string()
})

export type GetScheduleResponse = z.infer<typeof GetScheduleResponseSchema>

// ============================================================================
// GET /v1/school-users/:userId/schedule
// ============================================================================

export const GetUserScheduleResponseSchema = z.object({
  data: UserScheduleSchema,
  message: z.string()
})

export type GetUserScheduleResponse = z.infer<typeof GetUserScheduleResponseSchema>

// ============================================================================
// GET /v1/school-users/:userId/calendar
// ============================================================================

export const GetUserCalendarRequestSchema = z.object({
  startDate: z.string().optional(),
  endDate: z.string().optional()
})

export type GetUserCalendarRequest = z.infer<typeof GetUserCalendarRequestSchema>

export const GetUserCalendarResponseSchema = z.object({
  data: z.object({
    events: z.array(MeetingSchema),
    schedules: z.array(DayScheduleSchema).optional()
  }),
  message: z.string()
})

export type GetUserCalendarResponse = z.infer<typeof GetUserCalendarResponseSchema>
